import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { setOrganisationDomain } from "../../api/branding";
import Fido2DomainResetModal from "../common/Fido2DomainResetModal/Fido2DomainResetModal";

function BrandingGateOverlay({ onSuccess, rootDomainSuffix = ".xecurify.com" }) {
  const { t } = useTranslation();
  const [orgName, setOrgName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [fido2ConfirmModal, setFido2ConfirmModal] = useState(false);
  const [fido2AffectedUsers, setFido2AffectedUsers] = useState(0);
  const [pendingOrgName, setPendingOrgName] = useState(null);

  const handleSave = async () => {
    setError("");
    let name = (orgName || "").trim();
    if (!name) {
      setError(t("branding.pleaseEnterOrgName"));
      return;
    }
    // Organization name only (send as-is from input)
    const organizationName = name;
    setLoading(true);
    try {
      const { data, error: apiError } = await setOrganisationDomain({
        organisation_name: organizationName,
      });
      if (data?.requires_fido2_confirmation) {
        setLoading(false);
        setPendingOrgName(organizationName);
        setFido2AffectedUsers(data.affected_users);
        setFido2ConfirmModal(true);
        return;
      }
      if (apiError) {
        setError(
          (apiError?.message && Array.isArray(apiError.message) ? apiError.message.join(", ") : apiError?.message) ||
            "Failed to save branding. Please try again."
        );
        setLoading(false);
        return;
      }
      setLoading(false);
      if (typeof onSuccess === "function") onSuccess();
    } catch (e) {
      setLoading(false);
      setError("Something went wrong. Please try again.");
    }
  };

  const handleFido2ConfirmProceed = async () => {
    setFido2ConfirmModal(false);
    setLoading(true);
    try {
      const { data, error: apiError } = await setOrganisationDomain({ organisation_name: pendingOrgName, confirm_fido2_reset: true });
      setLoading(false);
      setPendingOrgName(null);
      if (apiError) {
        setError((apiError?.message && Array.isArray(apiError.message) ? apiError.message.join(", ") : apiError?.message) || "Failed to save branding. Please try again.");
        return;
      }
      if (typeof onSuccess === "function") onSuccess();
    } catch (e) {
      setLoading(false);
      setPendingOrgName(null);
      setError("Something went wrong. Please try again.");
    }
  };

  const handleFido2ConfirmCancel = () => {
    setFido2ConfirmModal(false);
    setPendingOrgName(null);
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.35)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
      }}
    >
      <div
        style={{
            width: "min(560px, 92vw)",
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 10px 24px rgba(0,0,0,0.18)",
            padding: 24,
        }}
      >
        <h3 style={{ margin: 0, marginBottom: 16 }}>{t("branding.setOrganisationBranding")}</h3>
        <p style={{ marginTop: 0, color: "#555" }}>
          {t("branding.enterOrgNameToContinue", { domain: rootDomainSuffix })}
        </p>

        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          <div style={{ flex: 1 }}>
            <label htmlFor="orgName" style={{ display: "block", fontSize: 12, color: "#444", marginBottom: 6 }}>
              {t("branding.organizationName")}
            </label>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <input
                id="orgName"
                type="text"
                placeholder={t("branding.orgNamePlaceholder")}
                value={orgName}
                onChange={(e) => setOrgName(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  borderRadius: 8,
                  border: "1px solid #dadce0",
                  outline: "none",
                }}
              />
              <div style={{ whiteSpace: "nowrap", color: "#333" }}>{rootDomainSuffix}</div>
            </div>
          </div>
        </div>

        {error ? <div style={{ color: "#b00020", marginTop: 12 }}>{error}</div> : null}

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 18 }}>
          <button
            onClick={handleSave}
            disabled={loading}
            style={{
              padding: "10px 16px",
              backgroundColor: "#0d6efd",
              color: "white",
              border: "none",
              borderRadius: 8,
              cursor: loading ? "not-allowed" : "pointer",
              minWidth: 120,
            }}
          >
            {loading ? t("branding.saving") : t("common.save")}
          </button>
        </div>
      </div>
      <Fido2DomainResetModal
        open={fido2ConfirmModal}
        affectedUsers={fido2AffectedUsers}
        onConfirm={handleFido2ConfirmProceed}
        onCancel={handleFido2ConfirmCancel}
      />
    </div>
  );
}

export default BrandingGateOverlay;


